<template>
  <div class="wrapper">
    <div id="loginWrap" class="wrap">
      <div class="noticeWrap" v-if="noticeStart">
        <h3 v-text="noticeData.title"></h3>
        <p v-html="noticeData.content"></p>
        <i></i>
        <i class="right"></i>
      </div>
      <!-- 登录页面首页 -->
      <loginView></loginView>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import loginView from "./pages/loginView.vue";
export default {
  name: 'App',
  components: {
    loginView
  }
  ,data() {
    return {
      noticeData:{}
      ,noticeStart:false
    }
  }
  ,mounted() {
    this.getNotice();
  }
  ,methods: {
    getNotice() {
      $.ajax({
        url: "static/utils/notice.json?" + Date.parse(new Date()),
        success: (data) => {
          this.noticeData = data;
          var nowTime = new Date(Date.now());
          if(nowTime >= new Date(data.startTime) && nowTime <= new Date(data.endTime)){
            this.noticeStart = true;
          }
        }
      });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.noticeWrap{
  position: relative;
  width: 100%;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  font-family: PingFangSC-Regular,PingFang SC;
  color: rgba(0,0,0,.6);
  background: rgba(255,252,240,1);
  box-shadow: 0px 1px 0px 0px rgba(229,222,212,1);
  overflow: hidden;
}
.noticeWrap h3{
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  margin: 0;
  font-size: 14px;
  font-family: PingFangSC-Semibold,PingFang SC;
  font-weight: 600;
  color: rgba(0,0,0,.8);
  background: rgba(255,252,240,1) url('images/login/ico_alert.svg') 22px center no-repeat;
  padding-left: 50px;
  width: 370px;
}
.noticeWrap p{
  margin: 0;
  position: absolute;
  left: 420px;
  top: 0;
  white-space: nowrap;
  overflow: hidden;
  padding-left: 50%;  /* 从右至左开始滚动 */
  animation: marqueeTransform 30s linear infinite;
}
/* 跑马灯（marquee文字超出一屏时，指定位置有bug） */
@keyframes marqueeTransform {
  0%   { transform: translate(0, 0); }
  100% { transform: translate(-100%, 0); }
}
.noticeWrap i{
  position: absolute;
  left: 420px;
  top: 0;
  display: block;
  width: 50px;
  height: 48px;
  FILTER: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=rgba(255,252,240,1),endColorStr=rgba(255,252,240,0)); /*IE 6 7 8*/
  background: -ms-linear-gradient(90deg, rgba(255,252,240,1) 0%, rgba(255,252,240,0) 100%);/* IE 10 */
  background: -moz-linear-gradient(90deg, rgba(255,252,240,1) 0%, rgba(255,252,240,0) 100%);/*火狐*/
  background: -webkit-linear-gradient(90deg, rgba(255,252,240,1) 0%, rgba(255,252,240,0) 100%);/*Safari5.1 Chrome 10+*/
  background: -o-linear-gradient(90deg, rgba(255,252,240,1) 0%, rgba(255,252,240,0) 100%);/*Opera 11.10+*/
  background: linear-gradient(90deg, rgba(255,252,240,1) 0%, rgba(255,252,240,0) 100%);
}
.noticeWrap i.right{
  left: auto;
  right: 0;
  FILTER: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=rgba(255,252,240,0),endColorStr=rgba(255,252,240,1)); /*IE 6 7 8*/
  background: -ms-linear-gradient(90deg, rgba(255,252,240,0) 0%, rgba(255,252,240,1) 100%);/* IE 10 */
  background: -moz-linear-gradient(90deg, rgba(255,252,240,0) 0%, rgba(255,252,240,1) 100%);/*火狐*/
  background: -webkit-linear-gradient(90deg, rgba(255,252,240,0) 0%, rgba(255,252,240,1) 100%);/*Safari5.1 Chrome 10+*/
  background: -o-linear-gradient(90deg, rgba(255,252,240,0) 0%, rgba(255,252,240,1) 100%);/*Opera 11.10+*/
  background: linear-gradient(90deg, rgba(255,252,240,0) 0%, rgba(255,252,240,1) 100%);
}
@import url("./style/media.css");
@import url("./style/login.css");

</style>



// WEBPACK FOOTER //
// src/App.vue